<template>
    <template v-if="freeLabel && price === 0">{{ snippets['headless.price.free'] }}</template>
    <template v-else-if="price != null">
        <span class="currency-symbol">&euro;&nbsp;</span><span class="currency-amount">{{ amount }}</span>
    </template>
</template>

<script setup lang="ts">
    const { snippets } = useSnippetsStore();

    const props = withDefaults(
        defineProps<{
            price: number | null | undefined;
            freeLabel?: boolean;
        }>(),
        { freeLabel: false },
    );

    const amount = computed(() =>
        new Intl.NumberFormat('nl-NL', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(props.price ?? 0),
    );
</script>
